module.exports = __webpack_public_path__ + "static/media/back-icon.aa78c834.svg";